import { ProcessStatusEnum, ProcessStatusLabels } from '@api/enum';
import { ICamera, IClient, IProject, IUser } from '@api/models';
import { IMultiImageLogs } from '@api/models/analytics.model';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface MultiImageLogsListProps {
    isLoading: boolean;
    multiImageLogsListData: IMultiImageLogs[];
}

const MultiImageLogsList = ({ isLoading, multiImageLogsListData }: MultiImageLogsListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={multiImageLogsListData}
            columns={[
                { header: 'ID' },
                { header: 'Date' },
                { header: 'Camera' },
                { header: 'Client' },
                { header: 'Project' },
                { header: 'Request By' },
                { header: 'Status' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{row._id}</Table.Cell>

                    <Table.Cell>{moment(row.createdAt, 'YYYYMMDDHHmmss').format('HH:mm A - DD MMM YYYY')}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/projects/${
                                (row.project as IProject)._id
                            }/cameras/${(row.camera as ICamera)._id}/edit-camera`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.camera as ICamera).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.client as IClient).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/projects/${
                                (row.project as IProject)._id
                            }/project-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.project as IProject).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/users/${
                                (row.requestedBy as IUser)._id
                            }/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.requestedBy as IUser).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Chip
                            label={ProcessStatusLabels[row.status]}
                            color={
                                row.status === ProcessStatusEnum.COMPLETED
                                    ? 'success'
                                    : row.status === ProcessStatusEnum.PENDING
                                    ? 'warning'
                                    : row.status === ProcessStatusEnum.EXPIRED
                                    ? 'danger'
                                    : 'primary'
                            }
                            variant="outlined"
                        />
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default MultiImageLogsList;
